export enum EnumTipoFiltroData {
    Vencimento = 0,
    Pagamento = 1,
    Emissao = 2,
    Cancelamento = 3,
    Bonificacao = 4
}